import React from "react";
import { isMobile } from "react-device-detect";

import {HOME_PLAYLIST} from "constant/playlist.display";
import ConditionWrapper from "components/ConditionWrapper";
import PlaylistLink from "components/boards/playlist/PlaylistLink";
import PlaylistThumb from "components/boards/playlist/PlaylistThumb";
import PlaylistInfo from "components/boards/playlist/PlaylistInfo";
import PlaylistVodsInfo from "components/boards/playlist/PlaylistVodsInfo";
import PlayListMoreButton from "components/boards/playlist/PlayListMoreButton";


const PlaylistItem = ({ playlistUser, authority = {}, inflowPath, thumbHeight, moreButtonTop, playlistPathType }) => {
    return (
        <>
            <ConditionWrapper condition={isMobile} wrapper={<PlaylistLink playlist={playlistUser.playlist} inflowPaths={inflowPath} playlistPathType={playlistPathType} />}>
                {/*/!* vod 썸네일 노출 *!/*/}
                <PlaylistThumb
                    playlist={playlistUser.playlist}
                    inflowPath={inflowPath}
                    height={thumbHeight}
                    playlistPathType={playlistPathType}
                />

                {/*/!* vod 정보 노출 *!/*/}
                {[HOME_PLAYLIST].includes(playlistPathType) ? (
                    {/* 채널 홈에서는 플레이 리스트 전체 VOD까지 노출
                        플레이 리스트 detail 단일 건 */}, 
                    <PlaylistVodsInfo playlistUser={playlistUser} inflowPath={inflowPath} playlistPathType={playlistPathType} />
                ) : (
                    {/* 플레이 리스트 대표 VOD */},
                    <PlaylistInfo playlistUser={playlistUser} inflowPath={inflowPath} />
                )}

            </ConditionWrapper>

            {/* 재생목록 컨트롤 버튼 (3dot) */}
            <PlayListMoreButton playlist={playlistUser.playlist} authority={authority} top={moreButtonTop} />
        </>
    );
}

export default PlaylistItem;
